module.exports = __webpack_public_path__ + "img/Refrig_Temp.79ff0547.png";